import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs';
import '../Technical.css';

class SetTransactionApprovalState extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                    ImageInformation Web Service
                    </h1>
                    <div>
                    <h2 className="main-subheading">
                            SetTransactionApprovalState</h2>
                    <div className="technical-main-content">
                        <p>
                            The SetTransactionApprovalState method can be used by the Service Aggregator to
                            indicate an approval decision of an account application, user authentication or
                            some other approval process. If the product has been configured to use this option,
                            then the image will not continue in the PCS process until a successful approved
                            decision has been indicated for the image. Once such a successful approval decision
                            has been received, the image will then be made available for image checking.</p>
                        <p>
                            As well as the decision, a comment can also be passed into the method. If a comment
                            is received then this will flag the image in the Image Checking module and the user
                            will be able to view the comment.</p>
                        <div>
                            <h3>
                                WSDL URL</h3>
                            <p>
                                Thales will provide the WSDL URL for DevServer during the project.</p>
                            <br />
                        </div>
                        <div>
                            <h3>
                                Request Parameters</h3>
                            <ul>
                                <li><b>CardImageID</b> (string):
                                    <p>
                                    The unique identifier for the image being requested, This is generated by the Designer
                                    Website and passed to the Subscriber during the Handback procedure.</p> </li>
                                <li><b>ImageInformation_Key</b> (GUID string):
                                <p>
                                    This value identifies the caller and is matched to the Service Aggregator. This
                                    guarantees that the caller should have access to the requested CardImageID. Thales
                                    will provide the Aggregator with the value for this parameter. Also note that a
                                    different value will be used on each environment (see the Handover URL section for
                                    an explanation of the environments).</p> </li>
                                <li><b>TransactionApprovalState</b> (string):
                                <p>
                                    This indicates whether the transaction has been approved or not. The parameter should
                                    either be a “1” for approved or “2” for not approved.</p> </li>
                                <li><b>Comment</b> (string):
                                <p>
                                    If a non-empty string is passed in then this will be indicated in the Image Checking
                                    module. If no comment then an empty string should be passed.</p> </li>
                            </ul>
                            <br/>
                        </div>
                        <div>
                            <h3>
                                Response Paramters</h3>
                            <ul>
                                <li><b>ErrorCode</b> (integer)
                                    <p>
                                    An error code describing the error (if any) that occurred during the method call.</p>
                                </li>
                            </ul>
                            <br/>
                        </div>
                        <div>
                            <h3>
                                Transaction Approval States</h3>
                            <ul>
                                <li><b>1 (Approved)</b> <p>the transaction for this image has been indicated as approved</p></li>
                                <li><b>2 (Not approved)</b><p>the transaction for this image has been indicated as unapproved</p></li>
                                <li><b>[Empty string]</b><p>no transaction approval descision for this image has been
                                    indicated</p></li>
                            </ul>
                            <br/>
                        </div>
                        <div>
                            <h3>
                                Error Codes</h3>
                            <ul>
                            <li><b>-2 (Unexpected system error)</b><p>An internal error occurred. This indicates that the caller is not allowed to make a request due to IP transparency check.</p></li>
                                <li><b>0 (Success)</b><p>The method call was successful.</p></li>
                                <li><b>-1 (Unexpected system error)</b><p>An internal error occurred. The caller should
                                    attempt to call the method again. If a high number of such errors are encountered,
                                    the problem should be escalated to manual operators at Thales.</p></li>
                                <li><b>0 (Success)</b><p>The method call was successful.</p></li>
                                <li><b>1 (CardImageID is invalid)</b><p>The CardImageID isn’t a valid identifier.</p></li>
                                <li><b>2 (ImageInformation_Key is invalid or doesn’t match CardImageId)</b><p>The CardImageID
                                    and ImageInformation_Key don’t match. This error will usually occur when an invalid
                                    or incorrect ImageInformation_Key is used.</p></li>
                                <li><b>3 (TransactionApprovalState is invalid)</b><p>The TransactionApprovalState isn’t
                                    of the value “1” or “2”.</p></li>
                            </ul>
                            <br/>
                        </div>
                        </div>
                        <div className="document-content-back">
                            <Link className="document-content-link" to='/technical/imageinformation'>Back</Link>
                        </div>
                        </div>
                    
                    </div>
                    </div>
        )
    }
}

export default SetTransactionApprovalState;